import { combineReducers } from '@reduxjs/toolkit';
import { favorite } from './favorite';

export default combineReducers({
    favorite,
});
